import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { icons } from '../../assets/icons';
import { TooltipDirective } from '../../directives/tooltip.directive';
import { IconSanitizerService } from './../../services/icon-sanitizer.service';

@Component({
    selector: 'lib-external-link',
    templateUrl: './external-link.component.html',
    styleUrls: ['./external-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, TooltipDirective]
})
export class ExternalLinkComponent implements OnInit {
    readonly icons = icons;

    private readonly iconSanitizerService: IconSanitizerService = inject(IconSanitizerService);

    message = input<string>('');
    url = input<string | undefined>(undefined);
    tooltip = input<string>('');
    openInSameTab = input<boolean>(false);

    externalLinkIcon?: SafeHtml;

    /**
     * Use a span instead of an anchor when no URL is provided.
     * This preserves semantic HTML while still allowing hover-based tooltips.
     */
    readonly hasLink = computed(() => !!this.url());
    readonly target = computed(() => (this.openInSameTab() ? '_self' : '_blank'));
    readonly rel = computed(() => (this.openInSameTab() ? null : 'noopener noreferrer'));

    ngOnInit(): void {
        this.externalLinkIcon = this.iconSanitizerService.getIcon('externalLink');
    }
}
